import Parse from "parse";

import type { SIV_GoodsReceiptProcessPosition } from "./SIV_GoodsReceiptProcessPosition";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_GoodsReceiptProcessPositionTextAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  goodsReceiptProcessPosition: SIV_GoodsReceiptProcessPosition;
  no: number;
  notFoundValues: any;
  tenant: OD3_Tenant;
  texts: any[];
  textsF: any[];
}

export class SIV_GoodsReceiptProcessPositionText extends Parse.Object<SIV_GoodsReceiptProcessPositionTextAttributes> {
  static className: string = "SIV_GoodsReceiptProcessPositionText";

  constructor(data?: Partial<SIV_GoodsReceiptProcessPositionTextAttributes>) {
    super(
      "SIV_GoodsReceiptProcessPositionText",
      data as SIV_GoodsReceiptProcessPositionTextAttributes,
    );
  }

  get goodsReceiptProcessPosition(): SIV_GoodsReceiptProcessPosition {
    return super.get("goodsReceiptProcessPosition");
  }
  set goodsReceiptProcessPosition(value: SIV_GoodsReceiptProcessPosition) {
    super.set("goodsReceiptProcessPosition", value);
  }

  get no(): number {
    return super.get("no");
  }
  set no(value: number) {
    super.set("no", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }

  get texts(): any[] {
    return super.get("texts");
  }
  set texts(value: any[]) {
    super.set("texts", value);
  }

  get textsF(): any[] {
    return super.get("textsF");
  }
  set textsF(value: any[]) {
    super.set("textsF", value);
  }
}

Parse.Object.registerSubclass(
  "SIV_GoodsReceiptProcessPositionText",
  SIV_GoodsReceiptProcessPositionText,
);
